/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import { Tabs, Upload, Button, Icon, Input, Spin } from 'antd';
import { DmsTab } from '../../components';
const TabPane = Tabs.TabPane;
import { openNotice, APIS, config } from 'Utils';
import { check, save} from '../../service/homeSet';
import './set.css';

class homeSetEdit extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      opts: ['banner设置'],
      btnLoad: false,
      loadList: false,
      key: 0,
      defaultActiveKey: 1,
      activeKey: 1,
      fileList: [],
      firstImgData: {
        'id': '',
        'attachId': '',
        'name': '',
        'fileCompressPath': '',
        'linkUrl': ''
      },
      secondImgData: {
        'id': '',
        'attachId': '',
        'name': '',
        'fileCompressPath': '',
        'linkUrl': ''
      },
      thirdImgData: {
        'id': '',
        'attachId': '',
        'name': '',
        'fileCompressPath': '',
        'linkUrl': ''
      },
      firstImgDataProps: {
        action: APIS.upload,
        onChange: this.updateFirstImg.bind(this),
        listType: 'picture',
        showUploadList: false,
        defaultFileList: [],
        className: 'upload-img-only'
      },
      secondImgDataProps: {
        action: APIS.upload,
        onChange: this.updateSecondImg.bind(this),
        showUploadList: false,
        listType: 'picture',
        defaultFileList: [],
        className: 'upload-img-only'
      },
      thirdImgDataProps: {
        action: APIS.upload,
        onChange: this.updateThirdImg.bind(this),
        showUploadList: false,
        listType: 'picture',
        defaultFileList: [],
        className: 'upload-img-only'
      }
    };
  }

  componentDidMount () {
    var self = this;
    self.setState({
      'loadList': true
    });
    check().then(function (result) {
      self.setState({
        'loadList': false
      });
      if (result && result.code == 200) {
        var resultData = result.data || [];
        for (let item of resultData) {
          if (item.sort == 1) {
            self.setState({
              'firstImgData': {
                ...self.state.firstImgData,
                'id': item.id,
                'attachId': item.attachId,
                'name': item.attachName,
                'fileCompressPath': item.fileCompressPath,
                'linkUrl': item.linkUrl
              }
            });
          } else if (item.sort == 2) {
            self.setState({
              'secondImgData': {
                ...self.state.secondImgData,
                'id': item.id,
                'attachId': item.attachId,
                'name': item.attachName,
                'fileCompressPath': item.fileCompressPath,
                'linkUrl': item.linkUrl
              }
            });
          } else if (item.sort == 3) {
            self.setState({
              'thirdImgData': {
                ...self.state.thirdImgData,
                'id': item.id,
                'attachId': item.attachId,
                'name': item.attachName,
                'fileCompressPath': item.fileCompressPath,
                'linkUrl': item.linkUrl
              }
            });
          }
        }
      } else {
        openNotice('error', '获取数据失败', (result && result.message) ? result.message : '');
      }
    });
  }

  updateFirstImg (result) {
    /* 第一张图片更新 */
    if (result.file.status === 'done') {
      var responseData = result.file.response || {};
      this.updateImgFn('update', 'firstImgData', responseData);
    }
  }

  updateSecondImg (result) {
    /* 第二张图片更新 */
    if (result.file.status === 'done') {
      var responseData = result.file.response || {};
      this.updateImgFn('update', 'secondImgData', responseData);
    }
  }

  updateThirdImg (result) {
    /* 第三张图片更新 */
    if (result.file.status === 'done') {
      var responseData = result.file.response || {};
      this.updateImgFn('update', 'thirdImgData', responseData);
    }
  }

  updateImgFn (type, field, result) {
    let stateData = {};
    if (type === 'delete') {
      stateData[field] = {
        ...this.state[field],
        id: '',
        name: '',
        attachId: '',
        fileCompressPath: '',
        linkUrl: ''
      };
      this.setState(stateData);
    } else {
      if (result.code != 200) {
        openNotice('error', '图片上传失败');
        return;
      }
      stateData[field] = {
        ...this.state[field],
        name: result.data.orginalName,
        attachId: result.data.id,
        fileCompressPath: result.data.fileCompressPath
      };
      this.setState(stateData);
    }
  }

  saveFn () {
    var self = this;
    self.setState({
      'btnLoad': true
    });
    let saveData = [];
    let imgData = this.state.firstImgData;
    if (imgData.fileCompressPath) {
      saveData.push({
        'id': imgData.id || '',
        'attachId': imgData.attachId || '',
        'attachName': imgData.name,
        'linkUrl': imgData.linkUrl,
        'imageType': 0
      });
    }
    imgData = this.state.secondImgData;
    if (imgData.fileCompressPath) {
      saveData.push({
        'id': imgData.id || '',
        'attachId': imgData.attachId || '',
        'attachName': imgData.name,
        'linkUrl': imgData.linkUrl,
        'imageType': 0
      });
    }
    imgData = this.state.thirdImgData;
    if (imgData.fileCompressPath) {
      saveData.push({
        'id': imgData.id || '',
        'attachId': imgData.attachId || '',
        'attachName': imgData.name,
        'linkUrl': imgData.linkUrl,
        'imageType': 0
      });
    }
    if (saveData.length == 0) {
      openNotice('warning', '提示', '请上传轮播图');
      self.setState({
        'btnLoad': false
      });
      return;
    }
    save(saveData).then(function (result) {
      self.setState({
        'btnLoad': false
      });
      if (result && result.code == 200) {
        openNotice('success', '保存成功', '');
      } else {
        openNotice('error', '保存失败', result.message || '');
      }
    });
  }

  tabFn (key) {
    let self = this;
    self.setState({
      activeKey: key
    });
  }

  stopUp (e) {
    e.stopPropagation();
  }

  moveImgFn (upDown, field, field2, e) {
    e.stopPropagation();
    let fieldData = this.state[field];
    let fieldData2 = this.state[field2];
    let stateData = {};
    stateData[field] = fieldData2;
    let stateData2 = {};
    stateData2[field2] = fieldData;
    this.setState(stateData);
    this.setState(stateData2);
  }

  deleteImgFn (field, e) {
    e.stopPropagation();
    this.updateImgFn('delete', field);
  }

  changeInput (e, field) {
    let stateData = {};
    stateData[field] = {
      ...this.state[field],
      linkUrl: e.target.value
    };
    this.setState(stateData);
  }

  render () {
    const { opts, key, defaultActiveKey, firstImgData, secondImgData, thirdImgData, firstImgDataProps, secondImgDataProps, thirdImgDataProps } = this.state;
    var self = this;
    return <div>
      <DmsTab options={opts} defaultKey={key}>
        <Button loading={this.state.btnLoad} type='primary' onClick={this.saveFn.bind(this)}>保存</Button>
      </DmsTab>
      <Spin spinning={this.state.loadList}>
        <div className="dms-table-box">
          <Tabs defaultActiveKey={defaultActiveKey + ''} onChange={this.tabFn.bind(this)}>
            <TabPane tab="首页-轮播图" key="1">
              <div className="img_icon">
                <Upload {...firstImgDataProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>图片上传</span>
                  <Button style={{display: !firstImgData.fileCompressPath || firstImgData.fileCompressPath.length==0 ? 'inline-block': 'none', marginRight: '10px'}}>
                    <Icon type="upload" />
                  </Button>
                  <span onClick={self.moveImgFn.bind(self, 'down', 'firstImgData', 'secondImgData')} className="up_down">下移</span>
                </Upload>
                <div className="set_upload_img" style={{display: !firstImgData.fileCompressPath || firstImgData.fileCompressPath.length==0 ? 'none': 'block'}}>
                  <img src={`${config.server}` + firstImgData.fileCompressPath} alt="" />
                  <p>{firstImgData.name}</p>
                  <i className="anticon anticon-delete" onClick={self.deleteImgFn.bind(self, 'firstImgData')}></i>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input placeholder="如：https://www.coralce.com" value={firstImgData.linkUrl} onChange={e => self.changeInput(e, 'firstImgData')} />
                </div>
              </div>
              <div className="img_icon">
                <Upload {...secondImgDataProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>图片上传</span>
                  <Button style={{display: !secondImgData.fileCompressPath || secondImgData.fileCompressPath.length==0 ? 'inline-block': 'none', marginRight: '10px'}}>
                    <Icon type="upload" />
                  </Button>
                  <span onClick={self.moveImgFn.bind(self, 'up', 'secondImgData', 'firstImgData')} className="up_down">上移</span>
                  <span onClick={self.moveImgFn.bind(self, 'down', 'secondImgData', 'thirdImgData')} className="up_down">下移</span>
                </Upload>
                <div className="set_upload_img" style={{display: !secondImgData.fileCompressPath || secondImgData.fileCompressPath.length==0 ? 'none': 'block'}}>
                  <img src={`${config.server}` + secondImgData.fileCompressPath} alt="" />
                  <p>{secondImgData.name}</p>
                  <i className="anticon anticon-delete" onClick={self.deleteImgFn.bind(self, 'secondImgData')}></i>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input placeholder="如：https://www.coralce.com" value={secondImgData.linkUrl} name="secondImgData" onChange={e => self.changeInput(e, 'secondImgData')} />
                </div>
              </div>
              <div className="img_icon">
                <Upload {...thirdImgDataProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>图片上传</span>
                  <Button style={{display: !thirdImgData.fileCompressPath || thirdImgData.fileCompressPath.length==0 ? 'inline-block': 'none', marginRight: '10px'}}>
                    <Icon type="upload" />
                  </Button>
                  <span onClick={self.moveImgFn.bind(self, 'up', 'thirdImgData', 'secondImgData')} className="up_down">上移</span>
                </Upload>
                <div className="set_upload_img" style={{display: !thirdImgData.fileCompressPath || thirdImgData.fileCompressPath.length==0 ? 'none': 'block'}}>
                  <img src={`${config.server}` + thirdImgData.fileCompressPath} alt="" />
                  <p>{thirdImgData.name}</p>
                  <i className="anticon anticon-delete" onClick={self.deleteImgFn.bind(self, 'thirdImgData')}></i>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input placeholder="如：https://www.coralce.com" value={thirdImgData.linkUrl} name="thirdImgData" onChange={e => self.changeInput(e, 'thirdImgData')} />
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    </div>
  }
}
;
export default homeSetEdit;


// WEBPACK FOOTER //
// ./src/routes/homeSet/edit.js